import {
  ACTIVITY_BUILDER_A4_LONG_SIDE,
  ACTIVITY_BUILDER_SLIDE_RATIO,
  SLIDE_HEIGHT_MINUS_HEADER_FOOTER,
} from './activity-builder.constants';

export const ACTIVITY_PREVIEW_FULL_SLIDE_RATIO =
  ACTIVITY_BUILDER_SLIDE_RATIO * 100;

export const ACTIVITY_PREVIEW_CONTENT_ONLY_RATIO =
  (SLIDE_HEIGHT_MINUS_HEADER_FOOTER / ACTIVITY_BUILDER_A4_LONG_SIDE) * 100;
